<template>
    <div ref="clickArea" class="click-area" @click="onClick" @animationend="endAnimation">
        <slot></slot>
        <div ref="shineDiv" class="shine" :style="{left: x + 'px', top: y + 'px'}"></div>
    </div>
</template>

<script>
    export default {
        props: {
        },
        methods: {
            onClick: function(e) {
                const clickArea = this.$refs.clickArea;
                const shineDiv = this.$refs.shineDiv;
                const clickAreaOffset = this.$mouseEventOffset(e, clickArea.$el);

                shineDiv.classList.remove('play'); //To reset animation
                this.x = clickAreaOffset[0];
                this.y = clickAreaOffset[1];

                setTimeout(() => shineDiv.classList.add('play'), 0);
            },
            endAnimation: function(e) {
                this.$refs.shineDiv.classList.remove('play');
            },
        },
        data: () => {
            return {
                x: 0,
                y: 0
            };
        }
    }
</script>

<style scoped lang="scss">
    .click-area {
        cursor: pointer;
        position: relative;
        overflow: hidden;

        width: 100%;
        height: 100%;

        &:hover {
            background-color: rgba(255, 255, 255, 0.2);
        }

        .shine {
            display: none;
            position: absolute;
            transform-origin: center;
            transform: translate(-50%, -50%);
            background-image: radial-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8));
            border-radius: 100%;
            width: 10px;
            height: 10px;

            &.play {
                display: block;
                animation: s 2s ease-out;
            }
        }
        
        @keyframes s {
            from {
                transform: translate(-50%, -50%) scale(0);
                opacity: 1;
            }
            to {
                transform: translate(-50%, -50%) scale(100);
                opacity: 0;
            }
        }
    }
</style>